module.exports = __webpack_public_path__ + "media/images/app/g-translate-a598ad2c9eef99ea6072d75156fffaf0.svg";